export function isImeComposing(e) {
    return Boolean(e.isComposing || e.nativeEvent?.isComposing || e.keyCode === 229);
}
// Dash look-alikes an IME produces for "-": the long-vowel mark ー, hyphens, minus.
// NFKC folds full-width forms (ＴＬ－１２３) but not these.
const DASHES = new RegExp('[\\u30FC\\u2010-\\u2015\\u2212\\uFF70]', 'g');
/**
 * A code typed by hand (QR code, sticker lookup) as ASCII. Case is kept: code
 * lookups are case-sensitive, so callers that know codes are uppercase say so.
 */
export function normalizeTypedCode(input) {
    return input.normalize('NFKC').replace(DASHES, '-').trim();
}
//# sourceMappingURL=ime.js.map